document.addEventListener('DOMContentLoaded', function () {

  function tryInject() {
    var rows = document.querySelectorAll('#cart-table-body strong');
    var ta = document.getElementById('products-25a9e81f-9518-45f8-bb08-76d46bdab02a');

    if (rows.length > 0 && ta) {
      var productsText = Array.from(rows)
        .map(function (el) { return el.textContent.replace(/\s+/g, ' ').trim(); })
        .filter(Boolean)
        .join('\n');
      ta.value = productsText;
    } else {
      setTimeout(tryInject, 300);
    }
  }

  tryInject();
});